import React, { ReactElement, Component, useState, useCallback, useMemo } from 'react';
// import { withRouter } from "react-router";
import { injectIntl, FormattedMessage } from 'react-intl';
// import { QuestionCircleFilled } from '@ant-design/icons';
import { Row, Input, Button, Card, notification, Form } from 'antd';
import { LOGIN_URL, pwdReg } from './login-util';
import { http_request_new } from '../../http-worker/http-func';
import { VisibleDelayed } from '../../shared-functions';
import { DrawerDelayedToShowPolicy } from './shared-functions';

// const DrawerDelayedToShow = (props: {
//   drawer_visible: 1 | undefined;
//   set_drawer_visible: React.Dispatch<React.SetStateAction<1 | undefined>>;
//   intl: IntlShape;
// }) => {
//   const handle_info_close = useCallback(() => {
//     props.set_drawer_visible(undefined);
//   }, [props.set_drawer_visible]);

//   return (
//     <Drawer
//       title={props.intl.formatMessage({ id: 'pwd_policy_title' })}
//       placement='bottom'
//       onClose={handle_info_close}
//       visible={!!VisibleDelayedInner(props.drawer_visible)}
//       height={230}
//       headerStyle={{ textAlign: 'center' }}
//       mask={false}
//     >
//       <Typography style={{ width: '400px', margin: '0 auto' }}>
//         <div
//           dangerouslySetInnerHTML={{
//             __html: marked(props.intl.formatMessage({ id: 'pwd_policy' }))
//           }}
//         />
//       </Typography>
//     </Drawer>
//   );
// };

export const ChangePwd = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [confirm_dirty, set_confirm_dirty] = useState(false);
  const [button_loading, set_button_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);
  const [drawer_visible, set_drawer_visible]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>();
  const { intl, history } = props;
  const logo_style = useMemo(() => props.logo_style, [props.logo_style])
  const [form] = Form.useForm();
  const { getFieldsValue, getFieldsError, isFieldsTouched } = form;
  const { code, username } = props.history.location.state;
  const sso_path = useMemo(() => props.sso_path?.replace(/^\//, '') || 'v4.0', [props.sso_path]);
  const handleConfirmBlur = useCallback(
    (e: any) => {
      const { value } = e.target;
      set_confirm_dirty(confirm_dirty || !!value);
    },
    [confirm_dirty]
  );

  const to_login = useCallback(() => {
    const redirectUri = sessionStorage.getItem('forSsoHomePath');
    if (redirectUri) {
      sessionStorage.removeItem('forSsoHomePath');
      window.location.href = redirectUri;
      return;
    }
    history.push(LOGIN_URL.signIn);
  }, [history]);

  const hasErrors = useCallback(() => {
    let validFiledsArr = ['new_pwd', 'new_pwd_again'];
    let hasErr = getFieldsError(validFiledsArr).some(({ errors }: any) => errors.length);
    return !isFieldsTouched(validFiledsArr, true) || hasErr;
  }, [getFieldsError, isFieldsTouched]);

  const handleSubmit = useCallback(async (): Promise<void> => {
    const { new_pwd } = getFieldsValue();
    set_button_loading(true);
    // 请求接口
    const request_body = {
      new_password: new_pwd
    };
    try {
      const send_res: any = await http_request_new({
        key: 'auth',
        props,
        url: `/${sso_path}/users/${username}/password?mode=reset&activationCode=${code}`,
        method: 4,
        body: request_body,
        no_refresh: 1
      });
      if (send_res && !send_res.code) {
        notification.success({
          message: intl.formatMessage({ id: 'success' }),
          description: intl.formatMessage({ id: 'reset_pwd_success' })
        });
        to_login();
      }
    } catch {
      set_button_loading(false);
    }
  }, [getFieldsValue, props, code, username, intl, to_login, sso_path]);

  // const handle_click_info = useCallback(() => {
  //   set_drawer_visible(1);
  // }, []);

  return (
    <Row className='change-password-content' justify='center' align='middle'>
      <Card className='change-password-box'>
        <Row className="logo-1" style={logo_style ? logo_style : {}}/>
        <Row className='box-title'>
          <FormattedMessage id='change_pwd'></FormattedMessage>
        </Row>
        {/* <Row className='box-subtitle'>
          <Col span={24}>
            <FormattedMessage id='change_pwd_sub'></FormattedMessage> &nbsp;
            <Tooltip title={intl.formatMessage({ id: 'help' })}>
              <QuestionCircleFilled style={{ color: '#1890ff' }} onClick={handle_click_info} />
            </Tooltip>
          </Col>
        </Row> */}

        <Form className='login-form' onFinish={handleSubmit} form={form}>
          <Form.Item
            name='new_pwd'
            required
            hasFeedback
            rules={[
              { required: true, message: intl.formatMessage({ id: 'p_i_password' }) },
              { pattern: pwdReg, message: intl.formatMessage({ id: 'p_c_pwd' }) }
            ]}
          >
            <Input.Password placeholder={intl.formatMessage({ id: 'new_password' })} size='large' iconRender={(_: any) => <span/>}/>
          </Form.Item>
          <Form.Item
            className={'new-pwd-again'}
            name='new_pwd_again'
            required
            hasFeedback
            dependencies={['new_pwd']}
            rules={[
              { required: true, message: intl.formatMessage({ id: 'p_i_password' }) },
              { pattern: pwdReg, message: intl.formatMessage({ id: 'p_c_pwd' }) },
              ({ getFieldValue }) => ({
                validator(_rule, value) {
                  if (!value || getFieldValue('new_pwd') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(intl.formatMessage({ id: 'two_pwd_unequal' }));
                }
              })
            ]}
          >
            <Input.Password onBlur={handleConfirmBlur} placeholder={intl.formatMessage({ id: 'confirm_new_password' })} size='large' iconRender={(_: any) => <span/>}/>
          </Form.Item>
          <Row className={'pwd-rule-desc'}>
            <FormattedMessage id="pwd_rule_prompt_and_desc"/>
          </Row>
          <Form.Item shouldUpdate>
            {() => (
              <Row justify='end' align='bottom'>
                <Button type='primary' size='large' htmlType='submit' className='form-submit-button' disabled={hasErrors()} loading={button_loading}>
                  {' '}
                  <FormattedMessage id='change_password'></FormattedMessage>{' '}
                </Button>
              </Row>
            )}
          </Form.Item>
        </Form>
        <Row justify='center'>
              <div className="divider mb-24 mt-0" />
              <span className='primary-link' onClick={to_login}>
                <FormattedMessage id='return_to_log_in'></FormattedMessage>
              </span>
            </Row>
      </Card>
      {!!VisibleDelayed(drawer_visible) && (
        <DrawerDelayedToShowPolicy {...{ intl, drawer_visible, set_drawer_visible, title: 'pwd_policy_title', height: 230, message: 'pwd_policy' }} />
      )}
    </Row>
  );
});
